// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../src/commons/components/SegmentsPopupContent/SegmentsPopupContent.less
// module id = 1817
// module chunks = 0